"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Forms/Patient.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _lodash = require('lodash');
var _reacthookform = require('react-hook-form');




var _peers = require('shared/selectors/peers');
var _org = require('shared/selectors/org');
var _time = require('shared/services/time');
var _patient = require('shared/validation/patient');
var _hooks = require('web/services/hooks');





var _Form = require('web/components/Form');
var _Modal = require('web/components/Modal');
var _TagField = require('./TagField'); var _TagField2 = _interopRequireDefault(_TagField);

const preventDefault = e => e.preventDefault()
























const makeDefaultValues = (
  patient,
  defaultEmail,
  defaultPhone,
  defaultFirstName,
  defaultLastName,
) => ({
  firstName: _optionalChain([patient, 'optionalAccess', _ => _.FirstName]) || defaultFirstName || '',
  lastName: _optionalChain([patient, 'optionalAccess', _2 => _2.LastName]) || defaultLastName || '',
  dob: _optionalChain([patient, 'optionalAccess', _3 => _3.DateOfBirth]) || '',
  email: _optionalChain([patient, 'optionalAccess', _4 => _4.Email]) || defaultEmail || '',
  phone: _optionalChain([patient, 'optionalAccess', _5 => _5.Phone]) || defaultPhone || '',
  foreignID: _optionalChain([patient, 'optionalAccess', _6 => _6.ForeignID]) || '',
})

const PatientForm = ({
  orgKeyContext,
  patientKey,
  isDisabled,
  isSubmitDisabled,
  className,
  controlsClassName,
  beforeControls,
  submitBtnLabel,
  onSubmit,
  onCancel,
  defaultEmail,
  defaultPhone,
  defaultFirstName,
  defaultLastName,
  hideOrgNotice,
  tags,
}) => {
  const [tagValue, setTagValue] = _react.useState(_TagField.EMPTY_TAG_FIELD)
  // Tags belong to an organization: choosing another one clears them
  // (review F-8), while the patient's fields stay as typed.
  const [tagOrgKey, setTagOrgKey] = _react.useState.call(void 0, orgKeyContext)
  if (tagOrgKey !== orgKeyContext) {
    setTagOrgKey(orgKeyContext)
    setTagValue(_TagField.EMPTY_TAG_FIELD)
  }
  const patient = _hooks.useAppSelector.call(void 0, 
    state => patientKey && _peers.selectPatientByKey.call(void 0, state, patientKey) || null,
  )
  const orgName = _hooks.useAppSelector.call(void 0, 
    state => orgKeyContext && _optionalChain([_org.selectOrgByKey.call(void 0, orgKeyContext, state), 'optionalAccess', _7 => _7.Name]) || '',
  )

  const { register, control, handleSubmit, formState, reset, getValues } =
    _reacthookform.useForm({
      resolver: _patient.patientResolver,
      mode: 'onChange',
      defaultValues: makeDefaultValues(
        patient,
        defaultEmail,
        defaultPhone,
        defaultFirstName,
        defaultLastName,
      ),
    })
  const { isValid, isSubmitting, errors } = formState

  // A refreshed record fills the form, unless it's being edited (its values
  // differ from the record it last filled in): a refresh never wipes what's
  // being typed.
  const filled = _react.useRef(null)
  _react.useEffect.call(void 0, 
    () => {
      if (!patient) return
      if (filled.current && !_lodash.isEqual.call(void 0, getValues(), filled.current)) return
      const next = makeDefaultValues(patient)
      filled.current = next
      reset(next)
    },
    [reset, getValues, patient],
  )

  return (
    _react2.default.createElement('form', { onSubmit: preventDefault, className: className, __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
      ,  orgName && !patientKey && !isDisabled && !hideOrgNotice && (
        _react2.default.createElement('span', { className: "directory--create-new--notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}, "This patient will be added to "
                , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}, orgName), "."
        )
      )
      , _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
        , _react2.default.createElement(_Form.InputSection, {
          autoFocus: !defaultFirstName,
          title: "First Name" ,
          placeholder: "E.g. John" ,
          inputProps: register('firstName'),
          isDisabled: isDisabled,
          isOptional: true,
          errorMessage: _optionalChain([errors, 'access', _8 => _8.firstName, 'optionalAccess', _9 => _9.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
        )
        , _react2.default.createElement(_Form.InputSection, {
          title: "Last Name" ,
          placeholder: "E.g. Parker" ,
          inputProps: register('lastName'),
          isDisabled: isDisabled,
          isOptional: true,
          errorMessage: _optionalChain([errors, 'access', _10 => _10.lastName, 'optionalAccess', _11 => _11.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}
        )
      )
      , _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}
        , _react2.default.createElement(_Form.InputSection, {
          title: "Email",
          autoFocus: !!(defaultFirstName && defaultLastName && !defaultEmail),
          placeholder: "E.g. john@email.com" ,
          inputProps: register('email'),
          isDisabled: isDisabled,
          errorMessage: _optionalChain([errors, 'access', _12 => _12.email, 'optionalAccess', _13 => _13.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}
        )
        , _react2.default.createElement(_Form.InputSectionWrapper, {
          title: "Phone",
          isDisabled: isDisabled,
          errorMessage: _optionalChain([errors, 'access', _14 => _14.phone, 'optionalAccess', _15 => _15.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}

          , _react2.default.createElement(_Form.PhoneInputController, {
            autoFocus: !!(defaultFirstName && defaultLastName && defaultEmail && !defaultPhone),
            control: control,
            name: "phone",
            isDisabled: isDisabled,
            hasError: !!errors.phone, __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}
          )
        )
      )
      , _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}
        , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Date of Birth"  , isOptional: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}}
          , _react2.default.createElement(_Form.DateInputController, {
            name: "dob",
            control: control,
            placeholder: `E.g. ${_time.TODAY_DISPLAY_DATE}`,
            isDisabled: isDisabled,
            className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}
          )
        )
        , _react2.default.createElement(_Form.InputSection, {
          title: "MRN",
          placeholder: "E.g. 0000001" ,
          inputProps: register('foreignID'),
          isOptional: true,
          isDisabled: isDisabled,
          errorMessage: _optionalChain([errors, 'access', _16 => _16.foreignID, 'optionalAccess', _17 => _17.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}
        )
      )
      ,  tags && (
        _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 198}}
          , _react2.default.createElement(_TagField2.default, {
            tags: tags,
            value: tagValue,
            onChange: setTagValue,
            createdWhen: "when you add the patient"    ,
            restingHint: "Tags are shared by everyone in your organization."       ,
            isDisabled: isDisabled,
            className: "blm-input-section directory--create-new--tags" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 199}}
          )
        )
      )
      ,  beforeControls 
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: submitBtnLabel,
        isPrimaryEnabled: isValid && !isSubmitting && !isDisabled && !isSubmitDisabled,
        onPrimaryBtnClick: handleSubmit(data => onSubmit(data, tagValue)),
        isPrimaryLoading: isSubmitting,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onCancel,
        className: controlsClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, PatientForm)
